import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';

export const RadioButton = styled.button<{ $checked: boolean }>`
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${color('contrast', 'light', 0.1)};
  background-color: transparent;
  position: relative;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${color('contrast', 'light')};
    opacity: ${(props) => (props.$checked ? 1 : 0)};
    transition: opacity 100ms linear;
  }
`;

export const SelectLabel = styled.span`
  color: ${color('custom', 'formInputPlaceholderColor')};
`;

export const MatchingItemLabel = styled.span`
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MatchingItemCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  .dx-button {
    height: 30px !important;
  }
`;
